var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobil4E(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/mobile"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mobile"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.24 2.43555H7.76C5 2.43555 4 3.43555 4 6.24555V18.6255C4 21.4355 5 22.4355 7.76 22.4355H16.23C19 22.4355 20 21.4355 20 18.6255V6.24555C20 3.43555 19 2.43555 16.24 2.43555ZM12 19.7355C11.04 19.7355 10.25 18.9455 10.25 17.9855C10.25 17.0255 11.04 16.2355 12 16.2355C12.96 16.2355 13.75 17.0255 13.75 17.9855C13.75 18.9455 12.96 19.7355 12 19.7355ZM14 6.68555H10C9.59 6.68555 9.25 6.34555 9.25 5.93555C9.25 5.52555 9.59 5.18555 10 5.18555H14C14.41 5.18555 14.75 5.52555 14.75 5.93555C14.75 6.34555 14.41 6.68555 14 6.68555Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobil4E);
export default __webpack_public_path__ + "static/media/mobil4e.cd7616111e73c51451b962dcb73982cd.svg";
export { ForwardRef as ReactComponent };